import React from "react";
import { withStyles } from "@material-ui/core/styles";
import DrawerStyles from "../../styles/drawerStyles";
import backIcon from "../../assets/backIcon.svg";
import Card from "./cards";
import ScheduleVisitCards from "./scheduledVisitCard";
import contentPaste from "../../assets/contentPaste.svg";
import phoneIcon from "../../assets/phone.svg";
import videoIcon from "../../assets/video.svg";

class Drawer extends React.Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
    this.selectedViewRef = React.createRef();
  }
  toggleDrawer = (bool) => {
    this.setState({ isOpen: bool });
    this.props.drawerValue && this.props.drawerValue(bool);
  };
  componentDidMount() {
    this.setState({ isOpen: true });
    this.props.drawerValue && this.props.drawerValue(true);
    this.selectedViewRef &&
      this.selectedViewRef.current &&
      this.selectedViewRef.current.scrollIntoView &&
      this.selectedViewRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
  }

  render() {
    let {
      classes,
      data = [],
      selectedCardData = {},
      handleRouteChange,
      routePath,
      title,
      isSearchType,
      callStarted,
    } = this.props;
    let CardComp = routePath === "scheduleCards" ? ScheduleVisitCards : Card;
    return (
      <div className={classes.drawer} data-app="drawer-component-wrapper">
        <div
          className={`${classes.drawerWrapper} ${
            !this.state.isOpen ? classes.closedDrawer : ""
          } `}
        >
          <div className={classes.drawercontainer}>
            <div className={classes.drawerHeader}>
              <div className={classes.drawerHeaderTitle}>{title}</div>
              <img
                alt=""
                id="drawerBackIcon"
                onClick={(_) => this.toggleDrawer(false)}
                className={classes.closeDrawerIcon}
                src={backIcon}
              />
            </div>
            <div className={classes.cardContainer}>
              {data.map((_) => {
                return (
                  <div
                    ref={
                      _.OrderId === selectedCardData.OrderId &&
                      this.selectedViewRef
                    }
                    className={classes.cardWrapper}
                  >
                    <CardComp
                      routePath={routePath}
                      callStarted={callStarted}
                      showSelectedStyle
                      isSearchType={isSearchType}
                      selected={_.OrderId === selectedCardData.OrderId}
                      src={
                        _.VisitType === 1
                          ? phoneIcon
                          : _.VisitType === 2
                          ? contentPaste
                          : videoIcon
                      }
                      handleRouteChange={handleRouteChange}
                      data={_}
                    />
                  </div>
                );
              })}
            </div>
          </div>
        </div>
        <div
          id="toggleDrawerDiv"
          onClick={(_) => this.toggleDrawer(true)}
          className={`${classes.openDrawerIcon} ${
            this.state.isOpen ? classes.hideDrawerIcon : ""
          }`}
        >
          <img alt="" className={classes.openImage} src={backIcon} />
        </div>
      </div>
    );
  }
}

export default withStyles(DrawerStyles)(Drawer);